module.exports = "/_next/static/images/4ca2d2495aa0d0e3143afdc9a4ae0090-roxinho-basicos-flutuantes-xs@3x.png.webp";